export const formatValue = (value: number): string => {
  return Intl.NumberFormat('es-CL',{ maximumFractionDigits: 0, useGrouping: true }).format(value);
}

export default {
  formatValue,
}